export default __webpack_public_path__ + "static/media/bannerbg.c6a50f70.png";